import { render, staticRenderFns } from "./PaymentMethodPanel.vue?vue&type=template&id=2a13fa34&scoped=true&"
import script from "./PaymentMethodPanel.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a13fa34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/demo.ec-direct.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a13fa34')) {
      api.createRecord('2a13fa34', component.options)
    } else {
      api.reload('2a13fa34', component.options)
    }
    module.hot.accept("./PaymentMethodPanel.vue?vue&type=template&id=2a13fa34&scoped=true&", function () {
      api.rerender('2a13fa34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/components/PaymentMethodPanel.vue"
export default component.exports